import { apiClient } from '../api/apiClient';

export const friendsService = {
    getDashboardCount() {
        return apiClient.get('friends/dashboard-count');
    },

    getFriends(userId) {
        return apiClient.post('friends/view', {
            json: { userId }
        });
    },

    getFriendRequests(userId) {
        return apiClient.post('friends/requests', {
            json: { userId }
        });
    },

    addFriend(requesterId, receiverIdentifier) {
        return apiClient.post('friends/add', {
            json: {
                requesterId,
                receiverIdentifier
            }
        });
    },

    addFriendByMemberPass(requesterId, memberPassToken) {
        return apiClient.post('friends/add-by-member-pass', {
            json: {
                requesterId,
                memberPassToken
            }
        });
    },

    acceptFriend(friendId) {
        return apiClient.post('friends/accept', {
            json: { FriendID: friendId }
        });
    },

    rejectFriend(friendId) {
        return apiClient.post('friends/reject', {
            json: { FriendID: friendId }
        });
    },

    removeFriend(friendId) {
        return apiClient.post('friends/remove', {
            json: { FriendID: friendId }
        });
    },

    cancelFriend(friendId) {
        return apiClient.post('friends/cancel', {
            json: { FriendID: friendId }
        });
    }
};
